import { Card } from "@/shared/ui/card.tsx";
import { Compass } from "lucide-react";
import { format, parse } from "date-fns";
import EditPostSheet from "@/shared/edit-post/EditPostSheet";
import { Dialog, DialogContent, DialogTrigger } from "@/shared/ui/dialog.tsx";
import { useAtomValue } from "jotai";
import { themeAtom } from "@/features/app-layout/atoms/theme-atoms";


type SocialCardProps = {
  content: {
    post_id: number;
    post_content: string;
    post_date: string;
    tags: string[];
    image_video_recommendation: string;
    post_time: string,
    platform: string,
    image_url: string,
    catalogue: string,
  },
  event_id: number
  event_name: string,
  event_status: "Scheduled" | "Pending"
}

const SocialCard = ({ content, event_name, event_id }: SocialCardProps) => {

  const theme = useAtomValue(themeAtom)

  return (
    <Card className="w-full group relative mt-1 p-5 pb-3 flex flex-col justify-around gap-3 rounded-2xl">
      <img src={`https://cdn.simpleicons.org/${(content.platform.toLowerCase().includes("twitter")) ? "x" : content.platform.toLowerCase()}`} className="absolute top-4 right-4 w-6 h-6" />
      <div className="flex items-center gap-2">
        <img src={theme.avatar} className="w-7 aspect-square rounded-full" />
        <div className="flex items-center gap-2">
          <p className="text-sm flex items-center gap-2 font-semibold">{theme.handle}
            <img src="https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9AcrbE4uO4h9zUp1a6MJqneWdFYX87yo52wmj" alt="" className="w-4" />
          </p>
          <p className="text-xs text-gray-400 font-poppins font-medium"> {format(parse(content.post_time, "HH:mm:ss", new Date()), "hh:mm a")} {" "}
            | {format(new Date(content.post_date), 'MMM dd, yyyy')}</p>
        </div>
      </div>
      <p className="text-xs lg:text-sm !leading-6 tracking-wide">{content.post_content}</p>
      {content.image_url !== null && content.image_url.length !== 0 && (
        <Dialog>
          <DialogTrigger>
            <div className="size-full relative group">
              <div className="absolute  group-hover:opacity-100 opacity-0 transition-opacity ease-in duration-700 flex p-4 inset-0 bg-gradient-to-b h-full flex-col justify-end items-start gap-2 from-black/0 via-black-10 to-black/70 rounded-xl">
                <p className="text-white font-semibold underline underline-offset-4">Image recommendation</p>
                <p className="text-white font-poppins text-sm text-start">{content.image_video_recommendation}</p>
              </div>
              <img
                src={content.image_url}
                loading="lazy"
                className="w-full h-fit rounded-lg cursor-pointer"
                alt="Preview"
                width="500px"
                height="500px"
              />
            </div>
          </DialogTrigger>
          <DialogContent className="max-w-2xl bg-black text-purple-500 font-semibold border-none outline-black p-0">
            <img src={content.image_url} className="w-full h-auto rounded-lg" alt="Full View" />
          </DialogContent>
        </Dialog>
      )}
      <div className="pt-2 border-t flex items-center justify-end gap-1 px-4">
        <EditPostSheet
          location="discarded"
          variant="pending"
          onSchedule={(id: number) => { console.log(id, "scheduled") }}
          postDetails={content}
          eventDetails={{ event_id, event_name }}
          trigger={<div className="flex gap-1 hover:bg-neutral-200 rounded-xl cursor-pointer py-1 px-2 items-center text-gray-500">
            <Compass size={13} />
            <span className="text-[0.6rem] lg:text-xs">Edit</span>
          </div>}
        />
        {/* event_status === "Pending" && <ConfirmScheduleDialog
            post_id={content.post_id}
            eventIndex={eventIndex}
            onSchedule={onSchedule}
            trigger={
              <button
                type="button"
                className="flex gap-1 hover:bg-neutral-200 rounded-xl cursor-pointer py-1 px-2 items-center text-gray-500">
                <Forward size={13} />
                <span className="text-[0.6rem] lg:text-xs">Approve</span>
              </button>
            } /> */}
      </div>
    </Card>
  )
}

export default SocialCard;
